import { connectCustom } from "@client/lib/misc";
import { type AppState, type EnhanceWidget, type WithClassName } from "@client/types";
import classnames from "classnames";
import Footer, { type FooterProps } from "./component";
import { classNameSelector, styleSelector, visibilitySelector } from "./selectors";

export type FooterContainerProps = Partial<WithClassName> & {
  enhance?: EnhanceWidget;
  children?: any;
};
const mapStateToProps = (state: AppState, props: FooterContainerProps): FooterProps => {
  const visibility = visibilitySelector(state);

  return {
    className: classnames(props.className, classNameSelector(state)),
    isVisible: visibility.isVisible,
    style: styleSelector(state),
    children: props.children,
    enhance: props.enhance
  };
};

export default connectCustom(mapStateToProps, null, { forwardRef: true })(Footer);
